export enum RegistrationCodeField {
  RegistrationCode = 'registrationCode',
}
